import { EnvType } from "../services";
import { IApiClient } from "../api-client";
import { ListGroupResponse } from "../Types/list-group-response";
import { ListGroupsResponse } from "../Types/list-groups-response";
import { UserListResponse } from "../Types/user-list-response";

interface IMessengerApiClient {
  ListAccessibleChatMembers(): Promise<UserListResponse>;
  ListGroups(): Promise<ListGroupsResponse>;
  ListGroupAndMessages(id: number): Promise<ListGroupResponse>;
}

export default class MessengerApiClient implements IMessengerApiClient {
  readonly servicePort = 9515;
  readonly serviceBaseUrl = "messenger-service/api";

  messengerApiClient: IApiClient;

  constructor(messengerApiClient: IApiClient, envType: EnvType) {
    this.messengerApiClient = messengerApiClient;
    if (envType === "local") this.messengerApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async ListAccessibleChatMembers(): Promise<UserListResponse> {
    return await this.messengerApiClient.get(`${this.serviceBaseUrl}/members`);
  }
  async ListGroups(): Promise<ListGroupsResponse> {
    return await this.messengerApiClient.get(`${this.serviceBaseUrl}/groups`);
  }
  async ListGroupAndMessages(id: number): Promise<ListGroupResponse> {
    return await this.messengerApiClient.get(`${this.serviceBaseUrl}/groups/${id}`);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.messengerApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
